import axios, { AxiosRequestConfig } from 'axios';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { clearSessionCredentials, getSessionCredentials } from '../globalFunctions';

export const useModule = (slug?: string) => {
  const token = getSessionCredentials()?.token ?? '';
  const navigate = useNavigate();

  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }
  };

  return useQuery({
    queryKey: ['module', slug],
    // garante que a query NÃO execute quando slug for falsy,
    // mas o hook useQuery é chamado sempre (mantendo ordem estável)
    enabled: !!slug,
    queryFn: async () => {
      // segurança: se slug for falsy, retornamos undefined (não tentamos acessar a API)
      if (!slug) return undefined;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/trilogic/module/${slug}`,
          requestConfig
        );
        return response.data;
      } catch (error: any) {
        const response = {
          message: 'Erro ao carregar os exercícios do módulo',
          error: error
        };

        if (error?.response && [401, 419].includes(error.response.status)) {
          // Unauthorized -> limpa credenciais e redireciona (se necessário)
          clearSessionCredentials(navigate);
        } else {
          console.error(response);
          return response;
        }
      }
    },
    // opcional: comportamento inicial
    initialData: undefined
  });
};
